module.exports = __webpack_public_path__ + "5f3953d8103a27dfe4a14f99335512ff.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/head/Lankenau2.jpg
// module id = 761
// module chunks = 0